(()=>{
const known={
    '6eeb5fcc-1f8b-43f6-b1b7-22244905f0f9': ['Thank you so much! Wonderful service and a fantastic watch. It looks very elegant on the wrist. We will definitely order again. Thank you!', 'Latvian', 'lv'],
    '985dd30b-5773-4110-b1ba-d03bafe7193a': ['Thank you, Chronoera!', 'Latvian', 'lv'],
    '7aa36447-7ce6-4ce0-b2bf-c0937463a16a': ['My watch arrived yesterday and I’m very happy! Delivery took a little longer, but at this price it was definitely worth the wait.', 'Lithuanian', 'lt'],
    '52187f5c-e2b7-49e7-b051-42ff615f02f8': ['Thank you—it arrived within a couple of days. Excellent quality.', 'Latvian', 'lv'],
    '09665c22-74dc-4c30-b73e-ee0959f30a98': ['I really like the watch. It feels comfortable on the wrist. You can see the Swiss quality :)', 'Lithuanian', 'lt'],
    '91fa2c85-cdb4-4ad7-9241-d1dc1f9dacab': ['I gave it to my husband as a gift, and he was very happy!', 'Lithuanian', 'lt'],
    '748e5f51-791a-48d8-9385-3396019059c6': ['The most beautiful watch I’ve ever seen! I’m very happy with my purchase!', 'Lithuanian', 'lt'],
    '11946e3c-b1eb-4b99-a072-7de23a9c5b02': ['I bought it as a gift for my son, and he was very happy!', 'Lithuanian', 'lt'],
    '2f33ee30-d37a-4330-9ae1-2328ca42f32a': ['A very beautiful watch, thank you :)', 'Latvian', 'lv'],
    '66641a6a-0381-4d5b-91c8-e4b03e02c59b': ['Very good quality.', 'Latvian', 'lv'],
    'b9396956-69c5-452a-acf7-605333e7b07a': ['Thank you, we received it :)', 'Latvian', 'lv'],
    '21515354-87f6-41fe-b0f0-63d765a0d57e': ['Great!', 'Lithuanian', 'lt']
  };
Object.assign(known,{"4c23fcef-8b46-4529-8c0d-0ebc88a7835c": ["I bought the watch for my son’s high-school graduation. He really liked the gift. I recommend it!", "Lithuanian", "lt"], "a6c88b7a-bf40-4bc7-ab45-064d6dfcb720": ["A great watch with a beautiful colour — it looks even better in person! I’m very happy with it.", "Lithuanian", "lt"], "48f350a4-1e4f-4010-b2b0-0780deeb7049": ["I ordered the watch as a gift. I have no complaints about the product itself — it is authentic, in impeccable condition, and looks amazing. But the shipping packaging was frankly inadequate. The corners of the branded watch box were dented during delivery, which spoiled the effect of giving the gift.", "Russian", "ru"], "c39cd169-3dfb-49e6-8cf7-8828457fcb6c": ["A great watch!", "Lithuanian", "lt"], "af81ec70-c3ed-4dc4-9f42-92ebfb6ecf72": ["I had to wait five days, but the price was excellent, and so was the quality of the watch.", "Latvian", "lv"]});

if (!customElements.get('chronoera-seastar-reviews')) {
 customElements.define('chronoera-seastar-reviews', class extends HTMLElement {
  connectedCallback() {
   if (this.observer || !document.documentElement.lang.startsWith('en')) return;
   const handled = new WeakSet();
   const translate = () => {
    this.querySelectorAll('.jdgm-card[data-review-id]').forEach(card => {
     if (handled.has(card)) return;
     const entry = known[card.dataset.reviewId];
     const text = card.querySelector('.jdgm-text > p');
     if (!entry || !text || !text.textContent.trim()) return;
     handled.add(card);
     card.dataset.chEnglish = 'true';
     const original = card.dataset.chOriginal || text.textContent;
     card.dataset.chOriginal = original;
     card.querySelector('.ch-sea-review-language')?.remove();
     const button = document.createElement('button');
     button.type = 'button';
     button.className = 'ch-sea-review-language';
     button.textContent = `Translated from ${entry[1]} · Show original`;
     button.setAttribute('aria-expanded','false');
     text.textContent = entry[0];
     text.lang = 'en';
     text.after(button);
     button.addEventListener('click', event => {
      event.stopPropagation();
      const showOriginal = button.getAttribute('aria-expanded') !== 'true';
      text.textContent = showOriginal ? original : entry[0];
      text.lang = showOriginal ? entry[2] : 'en';
      button.textContent = showOriginal ? 'Show English translation' : `Translated from ${entry[1]} · Show original`;
      button.setAttribute('aria-expanded', String(showOriginal));
     });
    });
   };
   this.observer = new MutationObserver(translate);
   this.observer.observe(this,{childList:true,subtree:true});
   translate();
  }
  disconnectedCallback() {this.observer?.disconnect();this.observer=null;}
 });
}
})();
